import React from "react";
import useSWR from "swr";
import cx from "classnames";

import { fetcher } from "../../../components/Overview/Overview";
import { filterEventTypeName } from "../Event";

export default function TabledElearningResults({ course, courseUUID, studentUUID }) {
    const findEndTermByMeasurementId = (end_terms, measurement_id) => {
        for (let end_term of end_terms) {
            for (let competence of end_term.competences) {
                for (let measurement of competence.measurements) {
                    if (measurement.uuid === measurement_id) {
                        return end_term;
                    }
                }
            }
        }
        return null;
    };

    const { data: eventResults } = useSWR(
        () =>
            courseUUID && studentUUID
                ? `/v1/courses/${courseUUID}/students/${studentUUID}/results/?event_type=elearning&fields=score_type_display,score_type_slug,score_type_value,event,measurement&pagination=false`
                : false,
        fetcher
    );
    const { data: courseEventsDetails } = useSWR(
        () =>
            courseUUID
                ? `/v1/courses/${courseUUID}/events/?fields=uuid,name,type,course,template,start_datetime,end_datetime,location,competence_profile,event_roles,is_editable&pagination=false`
                : null,
        fetcher
    );
    const { data: courseMeasurementsDetails } = useSWR(
        () =>
            courseUUID && studentUUID
                ? `/v1/users/${studentUUID}/courses/${courseUUID}/measurements/?fields=uuid,name,measurement_type&pagination=false&measurement_type=elearning`
                : null,
        fetcher
    );
    const { data: endTermsDetails } = useSWR(() => (course?.competence_profile ? `/v1/competenceprofiles/${course?.competence_profile.uuid}/end_terms/` : null), fetcher);

    const elearningEventResults = eventResults?.filter((o) => o.event.type === "elearning");
    const elearningEvents = courseEventsDetails?.filter((e) => ["elearning"].includes(e.type));

    if (!courseEventsDetails || !courseEventsDetails || !courseMeasurementsDetails) {
        return null;
    }

    return (
        <table className="table table-hover">
            <thead>
                <tr>
                    <th colSpan={4}>Onderdeel</th>
                    <th className="course-status-table__status">Status</th>
                </tr>
            </thead>
            <tbody>
                {courseMeasurementsDetails.map((elearning) => {
                    const result = elearningEventResults?.find((r) => r.measurement.uuid === elearning.uuid);
                    const resultEndTerm = findEndTermByMeasurementId(endTermsDetails, elearning.uuid);
                    const isExempted = course.competence_profile?.end_terms?.find((et) => et.uuid === resultEndTerm?.uuid)?.is_exempted === true;

                    let displayText = "Nog te doen";
                    let iconClass = "fa-ellipsis-h";
                    let textColor = "";

                    if (isExempted) {
                        displayText = "Vrijgesteld";
                        iconClass = "fa-check";
                        textColor = "text-success";
                    } else if (result?.score_type_slug === "achieved") {
                        displayText = result?.score_type_display;
                        iconClass = "fa-check";
                        textColor = "text-success";
                    } else if (result?.score_type_slug === "not_achieved") {
                        displayText = result?.score_type_display;
                        iconClass = "fa-times";
                        textColor = "text-danger";
                    }

                    return (
                        <tr key={elearning.uuid}>
                            <td colSpan={4}>
                                E-learning: <strong>{filterEventTypeName(elearning.name, "elearning")}</strong>
                            </td>
                            <td>
                                <span className={cx(textColor)}>
                                    <i className={cx("fa", iconClass)} /> {displayText}
                                </span>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
